// Guard для /upload/* routes: пропускает surveyDone и uploadAwaitingReview, иначе редиректит.
// Source: docs/specs/sprint-4/stage-4-frontend.md §5.2 + stage-1-contracts.md §8.1.
//
// v1.6 RF-28: decision-логика вынесена в pure helper decideSurveyCompletedRedirect для тестов.

import { Redirect } from 'wouter';
import type { ReactNode } from 'react';
import { useOnboardingState, type OnboardingState } from '@/hooks/useOnboardingState';
import { FullScreenSpinner } from '@/components/FullScreenSpinner';

/**
 * Pure decision helper. Возвращает redirect-target path или null (= render children).
 * Exported для §7.5 unit-тестов.
 */
export function decideSurveyCompletedRedirect(state: OnboardingState | undefined): string | null {
  if (!state) return '/signin';
  switch (state.kind) {
    case 'unauth':
      return '/signin';
    case 'verifyPending':
      return '/verify-code';
    case 'consentNeeded':
      return '/consent';
    case 'surveyPending':
      return `/survey/step-${state.resumeStep}`;
    case 'surveyDone':
    case 'uploadAwaitingReview':
    case 'uploadConfirmed1':
    case 'uploadConfirmedMany':
    case 'dashboardError':
      return null;
  }
}

export function RequireSurveyCompleted({ children }: { children: ReactNode }) {
  const { state, isLoading } = useOnboardingState();
  if (isLoading) return <FullScreenSpinner />;
  const target = decideSurveyCompletedRedirect(state);
  if (target) return <Redirect to={target} />;
  return <>{children}</>;
}
